(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-branding-new-sale"]) return;
  try {
    

$('.product-grid-item').each(function () {
    if ($(this).find('.js-collection-product-image-carousel').length) {
        var $thisImageCarousel = $(this).find('.js-collection-product-image-carousel');

        $thisImageCarousel.on('init', function () {
            $thisImageCarousel.find('[data-lazy]').each(function () {
                $(this).attr('src', $(this).attr('data-lazy'));
            })
        });

        $thisImageCarousel.slick({
            arrows: false,
            dots: false,
            infinite: false,
            fade: true
        });

        $(this).find('.js-collection-swatch').on('click', function (e) {
            e.preventDefault();
            var dataIndex = $(this).attr('data-index');
            $thisImageCarousel.slick('slickGoTo', dataIndex);
        })
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-branding-new"]) return;
  try {
    

$('.product-grid-item').each(function () {
    if ($(this).find('.js-collection-product-image-carousel').length) {
        var $thisImageCarousel = $(this).find('.js-collection-product-image-carousel');

        $thisImageCarousel.on('init', function () {
            $thisImageCarousel.find('[data-lazy]').each(function () {
                $(this).attr('src', $(this).attr('data-lazy'));
            })
        });

        $thisImageCarousel.slick({
            arrows: false,
            dots: false,
            infinite: false,
            fade: true
        });

        $(this).find('.js-collection-swatch').on('click', function (e) {
            e.preventDefault();
            var dataIndex = $(this).attr('data-index');
            $thisImageCarousel.slick('slickGoTo', dataIndex);
        })
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    

$('.product-grid-item').each(function () {
    if ($(this).find('.js-collection-product-image-carousel').length) {
        var $thisImageCarousel = $(this).find('.js-collection-product-image-carousel');

        $thisImageCarousel.on('init', function () {
            $thisImageCarousel.find('[data-lazy]').each(function () {
                $(this).attr('src', $(this).attr('data-lazy'));
            })
        });

        $thisImageCarousel.slick({
            arrows: false,
            dots: false,
            infinite: false,
            fade: true
        });

        $(this).find('.js-collection-swatch').on('click', function (e) {
            e.preventDefault();
            var dataIndex = $(this).attr('data-index');
            $thisImageCarousel.slick('slickGoTo', dataIndex);
        })
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-template-boost-pfs-filter"]) return;
  try {
    
    $('.js-boost-pfs-reset').click(function () {
      $(this).prev('input').val('').trigger('change').focus();
    })

  } catch(e) { console.error(e); }
})();
})();
